import { InputField } from '@atoms/input';

import type { TraceKeyModel } from '@models/traceKey/traceKey.model';
import { Button, FormControl, FormLabel, ToggleButtonGroup } from '@mui/joy';
import { TraceKeyMode } from '@stratumn/studio-shared';
import { observer } from 'mobx-react';

import { traceKeyModeDataMap } from './data';

type Props = {
  traceKey: TraceKeyModel;
  parentName?: string;
};

export const TraceKeyInput = observer(({ traceKey, parentName }: Props) => {
  const onTraceKeyChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    traceKey.setManualValue(e.target.value);
  };

  const onModeChange = (modeValue: unknown) => {
    if (!isChangeableMode(modeValue)) {
      return;
    }
    traceKey.setMode(modeValue, parentName);
  };
  return (
    <div className="flex w-full items-start gap-4">
      <div className="w-56">
        <InputField
          errors={traceKey.errors}
          label="Trace key"
          onChange={onTraceKeyChange}
          placeholder={traceKey.id}
          required
          value={traceKey.visualValue}
          warnings={traceKey.warnings}
        />
      </div>
      <FormControl size="sm">
        <FormLabel>Trace key mode</FormLabel>
        <ToggleButtonGroup
          onChange={(_, newValue) => {
            onModeChange(newValue);
          }}
          size="sm"
          value={traceKey.mode}
        >
          {Object.entries(traceKeyModeDataMap)
            .filter(([mode]) => (mode as TraceKeyMode) !== TraceKeyMode.Locked)
            .map(([mode, modeData]) => (
              <Button
                className="flex items-center gap-2"
                key={mode}
                size="sm"
                value={mode}
              >
                <modeData.icon size={16} />
                {modeData.label}
              </Button>
            ))}
        </ToggleButtonGroup>
      </FormControl>
    </div>
  );
});

const isChangeableMode = (
  mode: unknown
): mode is TraceKeyMode.Follow | TraceKeyMode.Free =>
  Object.values(TraceKeyMode).includes(mode as TraceKeyMode) &&
  (mode as TraceKeyMode) !== TraceKeyMode.Locked;
